'use strict';

angular.module('app.notificationScreenshot', [])

.controller('notificationProjectScreenshotCtrl', function ($scope, $rootScope, $stateParams, $http) {
    
    var request = {
        url: $rootScope.apiUrl + 'measure/getReportSections/' + $stateParams.report_id,
        method: 'GET'
    }

    $scope.loaded = false;
    $scope.sectionLoaded = 0;
    $scope.sectionList = [];
    $http(request).success(function (response) {
       $scope.sectionList = response.data.sectionList;

       $rootScope.selectedPeriod = {
            period: {
                value: $stateParams.period
            }
        }
        $rootScope.saveParams = {
            mention : 0,
            blog_id : 0,
            project_id : $stateParams.project_id,
            channel: 0,
            influencerGroup: 0
        };

        $rootScope.$broadcast('refreshDashboard');
    })
    .error(function (response) {
        
    });

    $scope.$on('sectionLoaded', function() {
        $scope.sectionLoaded = $scope.sectionLoaded + 1;
        if($scope.sectionLoaded == $scope.sectionList.length) {
            $scope.loaded = true;
        }
    })
})